import {jwtDecode} from 'jwt-decode'
import {UserToken} from 'src/contexts/AuthContext'
import storage from 'src/services/storage'

export function getDecodedToken(): UserToken {
  const token = storage.get('token') ?? ''
  const decodedToken = jwtDecode(token) as UserToken
  return decodedToken
}
